(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["duality-drawer-link"] && !Shopify.designMode) return;
  try {
    (() => {
    const animations = new WeakMap();

    document.addEventListener('click', event => {
      if (
        event.defaultPrevented ||
        !(event.target instanceof Element) ||
        !window.matchMedia('(max-width: 749px)').matches
      ) {
        return;
      }

      const summary = event.target.closest(
        'summary.duality-inline-navigation__heading'
      );

      if (!summary) return;

      const details = summary.parentElement;
      const panel = details.querySelector(
        ':scope > .duality-inline-navigation__children'
      );

      if (!panel) return;

      event.preventDefault();

      const previous = animations.get(details);
      const opening = previous
        ? !previous.opening
        : !details.open;

      const wasOpen = details.open;
      const startHeight = wasOpen
        ? panel.getBoundingClientRect().height
        : 0;

      const startOpacity = wasOpen
        ? Number.parseFloat(getComputedStyle(panel).opacity)
        : 0;

      previous?.animation.cancel();
      animations.delete(details);

      if (
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        details.open = opening;
        return;
      }

      /* Keep the content rendered until its exit has finished. */
      details.open = true;

      const targetHeight = opening ? panel.scrollHeight : 0;

      const animation = panel.animate(
        [
          {
            height: `${startHeight}px`,
            opacity: startOpacity
          },
          {
            height: `${targetHeight}px`,
            opacity: opening ? 1 : 0
          }
        ],
        {
          duration: opening ? 400 : 280,
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
          fill: 'both'
        }
      );

      animations.set(details, { animation, opening });

      animation.onfinish = () => {
        if (animations.get(details)?.animation !== animation) return;

        details.open = opening;
        animations.delete(details);
        animation.cancel();
      };
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["duality-fit-guide-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest(
      '[data-duality-size-guide-link]'
    );

    if (!link) return;

    const productArea = link.closest('.product-details');

    const originalTrigger = productArea?.querySelector(
      '[class*="ai-sizing-guide-button-"]'
    );

    if (!(originalTrigger instanceof HTMLElement)) return;

    event.preventDefault();
    originalTrigger.click();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["duality-gallery-position"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('duality-gallery-position')) {
    class DualityGalleryPosition extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('media-gallery');
        this.slideshow = this.gallery?.querySelector(
          'slideshow-component'
        );

        if (!this.slideshow) return;

        this.slideshow.addEventListener(
          'slideshow:select',
          this.onSelect
        );

        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];

          if (entry.isIntersecting) {
            this.update(this.slideshow.current ?? 0);
            this.reveal();
          } else {
            clearTimeout(this.timer);
            this.classList.remove('is-visible');
          }
        }, { threshold: 0.25 });

        this.observer.observe(this.slideshow);
        this.update(this.slideshow.current ?? 0);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();

        this.slideshow?.removeEventListener(
          'slideshow:select',
          this.onSelect
        );
      }

      onSelect = event => {
        if (event.target !== this.slideshow) return;

        this.update(event.detail.index);
        this.reveal();
      };

      update(index) {
        const slides = Array.from(
          this.slideshow.slides ||
          this.slideshow.querySelectorAll('slideshow-slide')
        );

        const count = slides.length;
        this.hidden = count <= 1;

        if (!count) return;

        const activeIndex = Number.isInteger(index)
          ? Math.max(0, Math.min(index, count - 1))
          : 0;

        this.style.setProperty('--position-count', count);
        this.style.setProperty('--position-index', activeIndex);
        this.setAttribute('aria-valuemax', count);
        this.setAttribute('aria-valuenow', activeIndex + 1);
      }

      reveal() {
        if (
          this.hidden ||
          !window.matchMedia('(max-width: 749px)').matches
        ) {
          return;
        }

        clearTimeout(this.timer);
        this.classList.add('is-visible');

        this.timer = setTimeout(() => {
          this.classList.remove('is-visible');
        }, 1800);
      }
    }

    customElements.define(
      'duality-gallery-position',
      DualityGalleryPosition
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["duality-mobile-purchase-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('duality-purchase-observer')) {
    class DualityPurchaseObserver extends HTMLElement {
      connectedCallback() {
        this.bar = this.closest('.duality-mobile-purchase-bar');
        if (!this.bar) return;

        this.mobile = window.matchMedia('(max-width: 749px)');
        this.resizeObserver = new ResizeObserver(this.update);

        this.resizeObserver.observe(this.bar);
        this.mobile.addEventListener('change', this.update);
        requestAnimationFrame(this.update);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.mobile?.removeEventListener('change', this.update);
      }

      update = () => {
        if (!this.bar?.isConnected || !this.mobile.matches) return;

        document.body.style.setProperty(
          '--duality-mobile-purchase-height',
          `${Math.ceil(this.bar.getBoundingClientRect().height)}px`
        );

        const quantity = this.bar.querySelector(
          '.quantity-selector input[name="quantity"]'
        );

        if (quantity) {
          const minimum = quantity.min || '1';

          if (quantity.value !== minimum) {
            quantity.value = minimum;
            quantity.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          }
        }
      };
    }

    customElements.define(
      'duality-purchase-observer',
      DualityPurchaseObserver
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["duality-model-caption"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('duality-photo-caption')) return;

    class DualityPhotoCaption extends HTMLElement {
      #gallery;
      #slide;
      #observer;
      #timer;
      #active = false;

      #desktopHover = window.matchMedia(
        '(min-width: 750px) and (hover: hover) and (pointer: fine)'
      );

      #reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      connectedCallback() {
        this.#gallery = this.closest('media-gallery');
        this.#slide = this.closest('slideshow-slide');

        if (!this.#gallery) return;

        this.#gallery.addEventListener(
          'slideshow:select',
          this.#onSlideSelect
        );

        this.#desktopHover.addEventListener(
          'change',
          this.#onModeChange
        );

        const imageBox =
          this.closest('.product-media') ||
          this.closest('.product-media-container');

        if (!imageBox) return;

        this.#observer = new IntersectionObserver(
          entries => {
            const entry = entries[0];

            if (!entry?.isIntersecting) {
              this.#reset();
              return;
            }

            if (
              this.#slide &&
              this.#slide.getAttribute('aria-hidden') === 'true'
            ) {
              return;
            }

            this.#show();
          },
          { threshold: 0.25 }
        );

        this.#observer.observe(imageBox);
      }

      disconnectedCallback() {
        this.#gallery?.removeEventListener(
          'slideshow:select',
          this.#onSlideSelect
        );

        this.#desktopHover.removeEventListener(
          'change',
          this.#onModeChange
        );

        this.#observer?.disconnect();
        this.#reset();
      }

      #onSlideSelect = event => {
        if (!this.#slide) return;

        const slideshow = this.#slide.closest('slideshow-component');

        if (event.target !== slideshow) return;

        if (event.detail?.slide !== this.#slide) {
          this.#reset();
          return;
        }

        this.#show();
      };

      #onModeChange = () => {
        this.#reset();

        if (this.#desktopHover.matches) return;

        if (
          this.#slide &&
          this.#slide.getAttribute('aria-hidden') === 'true'
        ) {
          return;
        }

        const box = this.closest('.product-media') ||
          this.closest('.product-media-container');

        if (!box) return;

        const bounds = box.getBoundingClientRect();

        if (
          bounds.bottom > 0 &&
          bounds.top < window.innerHeight &&
          bounds.right > 0 &&
          bounds.left < window.innerWidth
        ) {
          this.#show();
        }
      };

      #show() {
        if (
          this.#desktopHover.matches ||
          this.#active ||
          getComputedStyle(this).display === 'none'
        ) {
          return;
        }

        this.#active = true;
        window.clearTimeout(this.#timer);

        this.classList.remove('is-caption-visible');

        /* Restart the entrance when returning to this image. */
        void this.offsetHeight;

        this.classList.add('is-caption-visible');

        const entranceDuration = this.#reducedMotion.matches
          ? 120
          : 400;

        this.#timer = window.setTimeout(() => {
          this.classList.remove('is-caption-visible');
        }, entranceDuration + 3000);
      }

      #reset() {
        window.clearTimeout(this.#timer);
        this.#active = false;
        this.classList.remove('is-caption-visible');
      }
    }

    customElements.define(
      'duality-photo-caption',
      DualityPhotoCaption
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
